module.exports = __webpack_public_path__ + "static/fulllogo-10647d25a1b7a7f28e0d5f082de637b2.png";